var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CvBody",class:_vm.elmClasses},[_c('div',{staticClass:"CvBody__inner"},[_vm._v(" CvBody ")])])}
var staticRenderFns = []

export { render, staticRenderFns }